import { LicencePlate } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { tDefaults } from '../../../infrastructure/internationalisation'
import { Formatter } from '../types'

export const VehicleRegistrationFormatter: FunctionComponent<Formatter<string>> = ({
  value,
  t,
}) => {
  return value ? (
    <LicencePlate licencePlate={value} />
  ) : (
    <>{t(tDefaults('inputs.no-answer'))}</>
  )
}
